var s = Object.defineProperty;
var o = Object.getOwnPropertySymbols;
var i = Object.prototype.hasOwnProperty, f = Object.prototype.propertyIsEnumerable;
var d = (a, t, r) => t in a ? s(a, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : a[t] = r, c = (a, t) => {
  for (var r in t || (t = {}))
    i.call(t, r) && d(a, r, t[r]);
  if (o)
    for (var r of o(t))
      f.call(t, r) && d(a, r, t[r]);
  return a;
};
var e = (a, t) => {
  var r = {};
  for (var m in a)
    i.call(a, m) && t.indexOf(m) < 0 && (r[m] = a[m]);
  if (a != null && o)
    for (var m of o(a))
      t.indexOf(m) < 0 && f.call(a, m) && (r[m] = a[m]);
  return r;
};
import { jsx as S } from "react/jsx-runtime";
import { forwardRef as k } from "react";
import { S as l } from "../../Stack-CTaaXTID.js";
const u = k((n, m) => {
  var p = n, {
    "data-plum-id": a,
    className: t
  } = p, r = e(p, [
    "data-plum-id",
    "className"
  ]);
  return /* @__PURE__ */ S(
    l,
    c({
      ref: m,
      className: t,
      "data-plum-id": a
    }, r)
  );
});
u.displayName = "Stack";
export {
  u as Stack
};
